/* eslint-disable @next/next/no-img-element */
import { motion, useAnimation } from 'framer-motion';
import Link from '../../../Link';
import { useState, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import { TeamMembersFormat as TeamMembersFormatI } from '../../../../models/common';
import styles from './../../Team.module.scss';
import Img from './../../../Image';

const modalVariation = {
  visible: (props: { duration: number }) => ({
    y: '0',
    transition: {
      duration: props.duration,
      when: 'beforeChildren',
      staggerChildren: 0.054,
    },
  }),
  hidden: (props: { duration: number }) => ({
    y: '-100%',
    transition: {
      duration: props.duration,
      staggerChildren: 0.054,
      staggerDirection: -1,
      when: 'afterChildren',
    },
    transitionEnd: {
      display: 'none',
    },
  }),
};

const modalContentVariants = {
  visible: {
    y: '0%',
    opacity: 1,
    transition: {
      duration: 0.25,
    },
  },
  hidden: {
    y: '200%',
    opacity: 0,
    transition: {
      duration: 0.25,
    },
  },
};
const overVariation = {
  active: {
    opacity: 1,
  },
  inactive: () => ({
    opacity: 0,
  }),
};
const TeamListMember = (props: TeamMembersFormatI): JSX.Element => {
  const { name, image, role, question, link, answer, delay, className, index } =
    props;
  const modalControls = useAnimation();
  const [showModal, setShowModal] = useState<boolean | null>(null);
  const [mounted, setMounted] = useState(false);

  const isDesktop = useMediaQuery({ query: '(min-width: 900px)' });

  const showOverlay = async () => {
    if (!showModal) {
      modalControls.set({ display: 'block' });
      window.requestAnimationFrame(() => {
        modalControls.start('visible');
        setShowModal(true);
      });
    }
  };
  const hideOverlay = async () => {
    await modalControls.start('hidden');
    setShowModal(false);
  };
  useEffect(() => {
    if (showModal !== null && mounted) modalControls.set({ display: 'none' });
  }, [isDesktop]);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <div className={`${styles.teamMembercontainer} ${className}`}>
      <div
        className={styles.imgContainer}
        onClick={!isDesktop ? showOverlay : undefined}
      >
        <div>
          <div>
            <Img
              alt={image?.alt || ''}
              image={{ ...image, width: 342, height: 389 }}
            />
          </div>
        </div>
        {isDesktop && mounted ? (
          <motion.div
            initial={'inactive'}
            variants={overVariation}
            whileHover={'active'}
          >
            <div className={styles.overlay}>
              <div className={styles.overlayContent}>
                <div className={`${styles.overlayQuestion} text_5`}>
                  {question}
                </div>
                <div className={`${styles.overlayAnswer} text_2`}>{answer}</div>
              </div>
            </div>
          </motion.div>
        ) : null}
        {!isDesktop && process.browser && mounted ? (
          <motion.div
            initial={'hidden'}
            variants={modalVariation}
            custom={{
              duration: 0.3,
            }}
            animate={modalControls}
            className={styles.modal}
          >
            <button
              aria-label=""
              className={styles.modalBtnClose}
              type="button"
              onClick={() => {
                hideOverlay();
              }}
            ></button>
            <div className={styles.modalContent}>
              <motion.h4 variants={modalContentVariants}>{name} says</motion.h4>
              <motion.div variants={modalContentVariants} className="text_5">
                {question}
              </motion.div>
              <motion.div variants={modalContentVariants} className="text_1">
                {answer}
              </motion.div>
            </div>
          </motion.div>
        ) : null}
      </div>
      <div className={`h5_links ${styles.title}`}>{name}</div>
      <div className={`h7_links ${styles.subTitle}`}>{role}</div>
      <div className={styles.actionContainer}>
        {link && link?.url && (
          <Link
            href={link?.url || ''}
            type={link.style?.type}
            iconSize={link.style?.iconSize}
            textSize={link.style?.textSize}
            isIconFirst={link.style?.isIconFirst}
            isExternal={link.isExternal}
          >
            <img src={'/imgs/linkedin_icon.svg'} alt="" />
          </Link>
        )}
      </div>
    </div>
  );
};

export default TeamListMember;
